import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantOnboardingComponent } from './tenant-onboarding.component';
import { TenantOnboardingRoutingModule } from './tenant-onboarding-routing.module';
import { BreadcrumbModule } from '../../components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from '../../icons/icons.module';
import { TableModule } from 'src/app/table/table.module';
import { LeftSideNavigationModule } from 'src/app/layout/left-side-navigation/left-side-navigation.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { TenantOnboardingDetailsComponent } from './tenant-onboarding-details/tenant-onboarding-details.component';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SubscriptionTenantModule } from '../subscription-tenant/subscription-tenant.module';
import { MatMenuModule } from '@angular/material/menu';
@NgModule({
  declarations: [
    TenantOnboardingComponent,
    TenantOnboardingDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    TenantOnboardingRoutingModule,
    IconsModule,
    TableModule,
    LeftSideNavigationModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    ToolbarModule,
    PaginatorModule,
    MatProgressBarModule,
    SubscriptionTenantModule,
    MatMenuModule
  ]
})
export class TenantOnboardingModule { }

